export enum ClassificationEnum {
  UNCLASSIFIED = 'UNCLASSIFIED',
  FRIEND = 'FRIEND',
  UNKNOWN = 'UNKNOWN',
  WATCH = 'WATCH',
  SUSPECT = 'SUSPECT',
  ENEMY = 'ENEMY',
}

export enum ClassificationOriginEnum {
  COMPUTED = 'COMPUTED',
  MANUAL = 'MANUAL',
}

export interface Classification {
  classification: Record<string, ClassificationEnum> | ClassificationEnum;
  manualClassification: Partial<Record<string, ClassificationEnum>> | ClassificationEnum;
}
